import { render, staticRenderFns } from "./group-stat.vue?vue&type=template&id=12cde1c8&scoped=true"
import script from "./group-stat.vue?vue&type=script&lang=js"
export * from "./group-stat.vue?vue&type=script&lang=js"
import style0 from "./group-stat.vue?vue&type=style&index=0&id=12cde1c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cde1c8",
  null
  
)

export default component.exports